import { IntakeLabelCollection } from '@govalta-emu/alss-common';

//labels shown on the proceed page when applying on behalf of someone else
export const AishProceedOnBehalfLabels: IntakeLabelCollection = {
  accountSectionTitle: {
    label: 'Which Alberta.ca Account should you use?',
  },
  accountSectionDescription: {
    label: `This question will help you understand what account you should use to log in based on who will have to sign this application.`,
  },
  signingAuthority: {
    label: 'Do you have legal authority to sign for this person?',
  },
  signingAuthorityWorkRelated: {
    label: `Are you acting as this person's Power of Attorney or Trustee as part of your work?`,
  },
  signingAuthorityApplicantCanSign: {
    label: `Can the person you're applying for understand and sign the application themselves?`,
  },
};
